import React, { createContext, useState, useEffect } from 'react';
import Apiconnect from "./services/Apiconnect";

const AuthContext = createContext();

const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [userType, setUserType] = useState('');
  const [userInfo, setUserInfo] = useState(null);
  const [isLoading, setIsLoading] = useState(true);


  useEffect(() => {
    const token = localStorage.getItem('token');
    const storedUserType = localStorage.getItem('user_typ');

    if (token) {
      setIsAuthenticated(true);
      setUserType(storedUserType || '');
      fetchUserInfo(token);
    }
  }, []);



  const login = (userId, userType) => {
    setIsAuthenticated(true);
    setUserType(userType);
   
  };

  const logout = () => {
    // Clear all localStorage items
    localStorage.removeItem('token');
    localStorage.removeItem('u_email');
    localStorage.removeItem('u_name');
    localStorage.removeItem('user_typ');

    // Update state
    setIsAuthenticated(false);
    setUserType('');
   
    setUserInfo(null);
  };

  const fetchUserInfo = async (tooken) => {
    try {
      const response = await Apiconnect.postData("auth/userinfo", tooken);

      if (response.data && response.data.status === 1) {
        console.log(response.data.user);
        setUserInfo(response.data.user);
      } else {
        console.error("Failed to fetch user info:", response.data?.message);
      }
    } catch (error) {
      console.error("Error fetching user info:", error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <AuthContext.Provider value={{ isAuthenticated, userType, userInfo, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export { AuthContext, AuthProvider };